import api from './api';

const barcodeInventoryService = {
  listRanges: async (page = 1, pageSize = 25) => {
    const response = await api.get('/barcode-inventory/ranges', { params: { page, pageSize } });
    return response.data;
  },

  previewRange: async (payload) => {
    const response = await api.post('/barcode-inventory/ranges/preview', payload);
    return response.data;
  },

  createRange: async (payload) => {
    const response = await api.post('/barcode-inventory/ranges', payload);
    return response.data;
  },

  voidRange: async (rangeId, reason) => {
    const response = await api.post(`/barcode-inventory/ranges/${rangeId}/void`, { reason });
    return response.data;
  },

  lookup: async (barcode) => {
    const response = await api.get('/barcode-inventory/lookup', { params: { barcode } });
    return response.data;
  },

  voidBarcode: async (barcode, reason) => {
    const response = await api.post('/barcode-inventory/void', { barcode, reason });
    return response.data;
  },
};

export default barcodeInventoryService;
